import React from 'react';

const OrderCard = ({ order, onOpenDetails }) => {
    // 1. Dicionário de tradução e estilos
    const statusConfig = {
        pending: { label: 'PENDENTE', bg: '#fff3cd', color: '#856404' },
        paid: { label: 'PAGO', bg: '#d4edda', color: '#155724' },
        shipped: { label: 'DESPACHADO', bg: '#cce5ff', color: '#004085' }
    };

    // Pega a configuração baseada no status (ou um padrão caso venha algo diferente)
    const currentStatus = statusConfig[order.status?.toLowerCase()] || { 
        label: order.status?.toUpperCase(), 
        bg: '#eee', 
        color: '#333' 
    };

    const formattedTotal = new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: 'BRL'
    }).format(order.total || 0);

    const freteSelecionado = order.address?.frete?.name || "Não informado";

    return (
        <div style={{
            backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px',
            padding: '16px', marginBottom: '12px', display: 'flex',
            justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
            <div>
                <h4 style={{ margin: '0 0 5px 0' }}>Pedido #{order.order_id}</h4>
                <p style={{ margin: '2px 0', fontSize: '13px', color: '#555' }}>
                    <strong>Envio:</strong> {freteSelecionado}
                </p>
                <p style={{ margin: '2px 0', fontSize: '12px', color: '#888' }}>
                    {new Date(order.date).toLocaleString('pt-BR')}
                </p>
            </div>

            <div style={{ textAlign: 'right' }}>
                {/* 2. Aplicação da tradução e cores dinâmicas */}
                <span style={{
                    padding: '4px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold',
                    backgroundColor: currentStatus.bg,
                    color: currentStatus.color,
                    display: 'inline-block'
                }}>
                    {currentStatus.label}
                </span>
                
                <div style={{ fontWeight: 'bold', fontSize: '16px', marginTop: '8px' }}>{formattedTotal}</div>
                
                <button 
                    onClick={() => onOpenDetails(order)}
                    style={{ 
                        backgroundColor: '#333', color: 'white', border: 'none', 
                        padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', 
                        fontSize: '12px', marginTop: '8px' 
                    }}
                >
                    Detalhes
                </button>
            </div>
        </div>
    );
};

export default OrderCard;